/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2022
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/

import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Checkbox } from 'carbon-components-react';

import isEqual from 'lodash/isEqual';

export class TestToolScopes extends Component {
  constructor(props) {
    super(props);
    this.handleScopeChange = this.handleScopeChange.bind(this);
    this.state = {};
  }

  componentDidMount() {
    this.configure(this.props);
  }

  UNSAFE_componentWillReceiveProps(prevProps) {
    if (!isEqual(prevProps, this.props)) {
      this.configure(this.props);
    }
  }

  configure(props) {
    if (props.scopes) {
      let scopeStates = {};
      for (var i = 0; i < props.scopes.length; i++) {
        scopeStates[props.scopes[i]] = false;
      }

      this.setState(scopeStates);

      if (props.onChange && typeof props.onChange === 'function') {
        props.onChange(scopeStates);
      }
    }
  }

  handleScopeChange(scope, event) {
    let newState = Object.assign(this.state);

    if (typeof newState[scope] !== 'undefined') {
      newState[scope] = event;
    }

    this.setState(newState);

    if (this.props.onChange && typeof this.props.onChange === 'function') {
      this.props.onChange(newState);
    }
  }

  render() {
    let { t, scopes } = this.props;

    return (
      <div className="scopesChooser">
        <div className="labelText">{t('explorer_scopes')}</div>
        {scopes.map((scope) => {
          return (
            <Checkbox
              key={scope}
              labelText={scope}
              id={scope}
              checked={this.state[scope] ? this.state[scope] : false}
              onChange={(e) => this.handleScopeChange(scope, e)}
            />
          );
        })}
      </div>
    );
  }
}

export default withTranslation()(TestToolScopes);
